import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CreateRPNParams,
  CreateRPNResponse,
  GetEmployeeListToUpdateRPNParams,
  GetEmployeeListToUpdateRPNResponse,
  GetRPNListParams,
  GetRPNListResponse,
  UpdateRPNByEmployeeIdsParams,
  UpdateRPNByEmployeeIdsResponse,
} from '../types';

export const getRPNList = createAsyncThunk<
  GetRPNListResponse,
  GetRPNListParams
>(
  'rpn/getRPNList',
  async (params: GetRPNListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.rpn.main, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getEmployeeListToUpdateRPN = createAsyncThunk<
  GetEmployeeListToUpdateRPNResponse,
  GetEmployeeListToUpdateRPNParams
>(
  'rpn/getEmployeeListToUpdateRPN',
  async (params: GetEmployeeListToUpdateRPNParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.employee.getV2, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateRPNByEmployeeIds = createAsyncThunk<
  UpdateRPNByEmployeeIdsResponse,
  UpdateRPNByEmployeeIdsParams
>(
  'rpn/updateRPNByEmployeeIds',
  async (params: UpdateRPNByEmployeeIdsParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post(endPoints.rpn.main, params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const createRPNByEmployeeIds = createAsyncThunk<
  CreateRPNResponse,
  CreateRPNParams
>(
  'rpn/createRPNByEmployeeIds',
  async (params: CreateRPNParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post(endPoints.rpn.createNew, params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const rpnActs = {
  getRPNList,
  getEmployeeListToUpdateRPN,
  updateRPNByEmployeeIds,
  createRPNByEmployeeIds,
};
